const userType = {
  ALL: 1,
  EL: 2,
  VC: 3,
};

export default userType;
